// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "modal-2ZTpb";
var _4 = "title-31JUX";
var _5 = "subtitle-3Iw_-";
var _6 = "info-2dGeW";
var _7 = "info__icon-1siaM";
var _8 = "controls-2FnqR";
var _9 = "controls__cancel-39ei3";
var _a = "controls__continue-gn3J-";
var _b = "closeButton-3iZK8";
var _c = "passengers-2dkir";
var _d = "passenger-ItGiB";
var _e = "passenger__name-1h7H-";
var _f = "passenger__input-33ra-";
export { _1 as "__esModule", _2 as "mobile", _3 as "modal", _4 as "title", _5 as "subtitle", _6 as "info", _7 as "info__icon", _8 as "controls", _9 as "controls__cancel", _a as "controls__continue", _b as "closeButton", _c as "passengers", _d as "passenger", _e as "passenger__name", _f as "passenger__input" }
export default { "__esModule": _1, "mobile": _2, "modal": _3, "title": _4, "subtitle": _5, "info": _6, "info__icon": _7, "controls": _8, "controls__cancel": _9, "controls__continue": _a, "closeButton": _b, "passengers": _c, "passenger": _d, "passenger__name": _e, "passenger__input": _f }
